import type { PaginationProps } from './types';
import { PaginationCore } from './core';

export function ErpPagination({
  paginationModel,
  totalItems,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions,
  showPageSizeSelector,
  showQuickJump,
  showFirstLast = false,
  className
}: PaginationProps) {
  return (
    <PaginationCore
      paginationModel={paginationModel}
      totalItems={totalItems}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      pageSizeOptions={pageSizeOptions}
      showPageSizeSelector={showPageSizeSelector}
      showQuickJump={showQuickJump}
      showFirstLast={showFirstLast}
      className={className}
    />
  );
}
